import { getLicenses } from './getLicenses';
import { LicenseResponse } from '../models/LicenseResponse';
import { TransformedLicense } from '../models/License';
import { transformLicense, categorizeLicenses } from '../models/License';

export const getAllUnpairedLicenses = (): Promise<[TransformedLicense[], TransformedLicense[]]> =>
  Promise.allSettled([getLicenses('TMG', false), getLicenses('CLC', false)]).then(
    ([gridLicenses, curriculumLicenses]) =>
      ([] as TransformedLicense[])
        .concat(
          (gridLicenses.status === 'fulfilled' &&
            (gridLicenses.value.data.licenses as LicenseResponse[]).map(transformLicense)) ||
            [],
          (curriculumLicenses.status === 'fulfilled' &&
            (curriculumLicenses.value.data.licenses as LicenseResponse[]).map(transformLicense)) ||
            []
        )
        .reduce(categorizeLicenses, [[], []])
  );
